module.exports = __webpack_public_path__ + "img/Quizz_0005_motorista.d52c47a8.png";